import React from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router'
import NProgress from 'nprogress'
import { translate } from 'react-i18next'
import Head from 'next/head';
import { CookieBanner } from '@palmabit/react-cookie-law';

import stylesheet from '../../styles/main.scss'
import Header from './header'
import Footer from './footer'
import Menu from '../menu';

Router.onRouteChangeStart = () => NProgress.start()
Router.onRouteChangeComplete = () => NProgress.done()
Router.onRouteChangeError = () => NProgress.done()


class Page extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuVisible: false,
      loading: 'is-loading'
    }
    this.handleToggleMenu = this.handleToggleMenu.bind(this)
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ loading: '' });
    }, 100);
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  handleToggleMenu() {
    this.setState({
      isMenuVisible: !this.state.isMenuVisible
    })
  }

  render() {
    const { t, i18n: { language }, children, ready } = this.props;
    return (
      <div className={`body ${ready ? '' : this.state.loading} ${this.state.isMenuVisible ? 'is-menu-visible' : ''}`}>
        <Head>
          <title>E. SASSONE</title>
          <meta name="description" content="E. SASSONE"/>
          <link href="/static/css/skel.css" rel="stylesheet"/>
          <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"/>
          <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,300i,600,600i" rel="stylesheet"/>
          <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        </Head>
        <style dangerouslySetInnerHTML={{ __html: stylesheet }}/>

        <div id="wrapper">
          <Header onToggleMenu={this.handleToggleMenu}/>
          {ready ? children() : (
            <>
              {t('loading')}
            </>
          )}
          <Footer/>
        </div>
        <Menu onToggleMenu={this.handleToggleMenu}/>
        <CookieBanner
          message={t('privacy:cookie_law')}
          necessaryOptionText={t('privacy:required')}
          acceptButtonText={t('privacy:accept')}
          policyLink={`/${language}/privacy`}
          // onAccept = {() => {}}
          showPreferencesOption={false}
          showStatisticsOption={false}
          showMarketingOption={false}
          styles={{
            dialog: {
              backgroundColor: '#24252a',
              color: 'white',
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 100000,
              padding: 10,
            },
            message: {
              minHeight: 32,
              fontSize: 15,
              fontWeight: 400,
              lineHeight: '130%',
              padding: '10px 0',
              color: 'white'
            },
            policy: {
              fontSize: 15,
              marginLeft: 10,
              color: 'white',
              textDecoration: 'underline',
            }
          }}
        />
      </div>
    )
  }
}

export default translate()(Page)
